import queryString from "query-string"
import { BASE_PATH, StatisticSaleGetGroupGroupByEnum } from "./backend/src"
import { TokenName } from "../vars/system"

const serverPath = process.env.NEXT_PUBLIC_SALES_API || ""

// Returns base path with server path if needed
export const getBasePath = () => {
  return serverPath + BASE_PATH
}

import { authStorageAdapter } from "../auth/storageAdapter"

// Returns base path with server path if needed
export const getAccessToken = (): string => {
  const token = authStorageAdapter.getInMemoryTokenSync() || ""
  // В Cookie-flow не отправляем заголовок Authorization с UUID.
  // В Authorization: Bearer должен передаваться только актуальный токен сессии Kratos (ory_st_...)
  if (token && typeof token === "string" && token.startsWith("ory_st_")) {
    return token
  }
  return ""
}

// -------------------------------------------------
// auth (migrated to Ory Kratos)
// -------------------------------------------------

// -------------------------------------------------
// enterprise
// -------------------------------------------------

export const UrlEnterpriseGetOneAPI = (enterpriseId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId
export const UrlEnterpriseGetListAPI = () => getBasePath() + "/enterprise"

// -------------------------------------------------
// user
// -------------------------------------------------

export const UrlUserGetOneAPI = (enterpriseId, userId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/user/" + userId
export const UrlUserGetListAPI = (enterpriseId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/user"

// -------------------------------------------------
// shop
// -------------------------------------------------

export const UrlShopGetOneAPI = (enterpriseId, shopId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/shop/" + shopId
export const UrlShopGetAllShopsForUserAPI = (enterpriseId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/shop"
export const UrlShopGetAllUsersInShopAPI = (enterpriseId, shopId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/shop/" + shopId + "/user"
export const UrlShopGetAvailableToAddUserToShopAPI = (
  enterpriseId,
  shopId: string
) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/shop/" +
  shopId +
  "/user/availableToAdd"

// -------------------------------------------------
// category
// -------------------------------------------------

export const UrlCategoryGetOneAPI = (enterpriseId, categoryId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/category/" + categoryId
export const UrlCategoryGetAllAPI = (enterpriseId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/category"

// -------------------------------------------------
// pricing
// -------------------------------------------------

export const UrlPricingGetOneAPI = (enterpriseId, pricingId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/pricing/" + pricingId
export const UrlPricingGetAllAPI = (enterpriseId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/pricing"

// -------------------------------------------------
// item
// -------------------------------------------------

export const UrlItemGetOneAPI = (enterpriseId, itemId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/item/" + itemId
export const UrlItemFindListAPI = (
  enterpriseId,
  {
    shopId,
    categoryId,
    searchText,
    limit,
    offset,
  }: {
    shopId?: string
    categoryId?: string
    searchText?: string
    limit?: number
    offset?: number
  }
) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/item" +
  `?${queryString.stringify(
    {
      shopId: shopId || null,
      categoryId: categoryId || null,
      searchText: searchText || null,
      limit: limit || null,
      offset: offset || null,
    },
    { skipNull: true }
  )}`

// -------------------------------------------------
// order
// -------------------------------------------------

export const UrlOrderCreateOneAPI = (enterpriseId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/order"

export const UrlOrderGetOneAPI = (enterpriseId, orderId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/order/" + orderId
export const UrlOrderFindListAPI = (
  enterpriseId,
  {
    shopId,
    shopSalePointId,
    shopPaymentPointId,
    userId,
    fromDate,
    toDate,
    limit,
    offset,
  }: {
    shopId?: string
    shopSalePointId?: string
    shopPaymentPointId?: string
    userId?: string
    fromDate?: string
    toDate?: string
    limit?: number
    offset?: number
  }
) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/order" +
  `?${queryString.stringify(
    {
      shopId: shopId || null,
      shopSalePointId: shopSalePointId || null,
      shopPaymentPointId: shopPaymentPointId || null,
      userId: userId || null,
      fromDate: fromDate || null,
      toDate: toDate || null,
      limit: limit || null,
      offset: offset || null,
    },
    { skipNull: true }
  )}`
export const UrlOrderGetAllSumInShopsAPI = (enterpriseId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/order/total/shop"
export const UrlOrderGetAllSumInShopAPI = (enterpriseId, shopId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/order/total/shop/" + shopId
export const UrlOrderGetAllSumInShopSalePointsAPI = (
  enterpriseId,
  shopId: string
) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/order/total/shop/" +
  shopId +
  "/shopSalePoint"
export const UrlOrderGetAllSumInShopSalePointAPI = (
  enterpriseId,
  shopId,
  shopSalePointId: string
) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/order/total/shop/" +
  shopId +
  "/shopSalePoint/" +
  shopSalePointId
export const UrlOrderGetAllSumInShopPaymentPointsAPI = (
  enterpriseId,
  shopId,
  shopSalePointId: string
) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/order/total/shop/" +
  shopId +
  "/shopSalePoint/" +
  shopSalePointId +
  "/shopPaymentPoint"
export const UrlOrderGetAllSumInShopPaymentPointAPI = (
  enterpriseId,
  shopId,
  shopSalePointId,
  shopPaymentPointId: string
) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/order/total/shop/" +
  shopId +
  "/shopSalePoint/" +
  shopSalePointId +
  "/shopPaymentPoint/" +
  shopPaymentPointId

// -------------------------------------------------
// shopSalePoint
// -------------------------------------------------

export const UrlShopSalePointFindOneAPI = (
  enterpriseId,
  shopSalePointId: string
) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/shopSalePoint/" +
  shopSalePointId
export const UrlShopSalePointFindListAPI = (enterpriseId, shopId?: string) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/shopSalePoint" +
  `?${queryString.stringify({ shopId: shopId })}`

// -------------------------------------------------
// shopPaymentPoint
// -------------------------------------------------

export const UrlShopPaymentPointFindOneAPI = (
  enterpriseId,
  shopPaymentPointId: string
) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/shopPaymentPoint/" +
  shopPaymentPointId
export const UrlShopPaymentPointFindListAPI = (
  enterpriseId,
  shopId?,
  shopSalePointId?: string
) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/shopPaymentPoint" +
  `?${queryString.stringify({
    shopId: shopId,
    shopSalePointId: shopSalePointId,
  })}`

// -------------------------------------------------
// sale
// -------------------------------------------------

export const UrlSaleCreateOneAPI = (enterpriseId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/sale"
export const UrlSaleGetOneAPI = (enterpriseId, saleId: string) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/sale/" + saleId
export const UrlSaleFindListAPI = (
  enterpriseId,
  {
    fromDate,
    toDate,
    shopId,
    shopSalePointId,
    shopPaymentPointId,
    userId,
  }: {
    fromDate?: string
    toDate?: string
    shopId?: string
    shopSalePointId?: string
    shopPaymentPointId?: string
    userId?: string
  }
) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/sale" +
  `?${queryString.stringify(
    {
      fromDate: fromDate || null,
      toDate: toDate || null,
      shopId: shopId || null,
      shopSalePointId: shopSalePointId || null,
      shopPaymentPointId: shopPaymentPointId || null,
      userId: userId || null,
    },
    { skipNull: true }
  )}`
export const UrlSaleGetAllItemsInSaleAPI = (
  enterpriseId: string,
  saleId: string
) =>
  getBasePath() + "/enterprise/" + enterpriseId + "/sale/" + saleId + "/items"

// -------------------------------------------------
// statistic
// -------------------------------------------------

export const UrlStatisticSaleTotalAPI = (
  enterpriseId,
  {
    fromDate,
    toDate,
    shopId,
    shopSalePointId,
    shopPaymentPointId,
    userId,
  }: {
    fromDate?: string
    toDate?: string
    shopId?: string
    shopSalePointId?: string
    shopPaymentPointId?: string
    userId?: string
  }
) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/statistic/sale/total" +
  `?${queryString.stringify(
    {
      fromDate: fromDate || null,
      toDate: toDate || null,
      shopId: shopId || null,
      shopSalePointId: shopSalePointId || null,
      shopPaymentPointId: shopPaymentPointId || null,
      userId: userId || null,
    },
    { skipNull: true }
  )}`

export const UrlStatisticSaleGroupAPI = (
  enterpriseId,
  groupBy: StatisticSaleGetGroupGroupByEnum,
  {
    fromDate,
    toDate,
    shopId,
    shopSalePointId,
    shopPaymentPointId,
    userId,
  }: {
    fromDate?: string
    toDate?: string
    shopId?: string
    shopSalePointId?: string
    shopPaymentPointId?: string
    userId?: string
  }
) =>
  getBasePath() +
  "/enterprise/" +
  enterpriseId +
  "/statistic/sale/group" +
  `?${queryString.stringify(
    {
      fromDate: fromDate || null,
      toDate: toDate || null,
      shopId: shopId || null,
      shopSalePointId: shopSalePointId || null,
      shopPaymentPointId: shopPaymentPointId || null,
      userId: userId || null,
      groupBy: groupBy,
    },
    { skipNull: true }
  )}`
